

"use client";
type Props = {
  title: string;
};

function renderLine(line: string) {
  const parts = line.split(/(\[.*?\])/g);

  return parts.map((part, index) => {
    const isHighlighted = part.startsWith("[") && part.endsWith("]");

    if (isHighlighted) {
      const text = part.slice(1, -1);

      return (
        <span
          key={index}
          className="inline-block text-[30px] 3xl:text-[44px] bg-pink font-heading rounded-lg text-beige px-3 py-0.5 mx-1 -rotate-2  uppercase tracking-widest"
        >
          {text}
        </span>
      );
    }

    return <span key={index}>{part}</span>;
  });
}

export default function HeroTitle({ title }: Props) {
  const lines = title.split("\n");
 return (
     <h1 className="text-[42px]  font-literata font-bold ">
      {lines.map((line, index) => (
        <div key={index}>{renderLine(line)}</div>
      ))}
    </h1>
  );
}